import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import BasicModal from 'components/Modals/presets/BasicModal';
import Select from 'components/Inputs/Select';
import { NoOptionsMessage } from 'components/Inputs/Select/customize';

const ModalContents = styled.div`
  height: 190px; // height to accommodate menu open w/o scrolling
`;

const ConfirmActionModal = ({
  onHide,
  selectionOptions,
  onConfirm,
  show,
  onMenuOpen,
  ...props
}) => {
  const { t } = useTranslation();
  const [option, setOption] = useState(null);
  const [isDisabledNext, setIsDisabledNext] = useState(true);
  const nextAction = () => {
    if (option && option.value) {
      onConfirm(option.value);
    }
    setOption(null);
  };

  useEffect(() => {
    if ((option && option.numberContacts === 0) || option === null) {
      setIsDisabledNext(true);
    } else {
      setIsDisabledNext(false);
    }
  }, [option]);

  return (
    <BasicModal
      buttonText={t('Next')}
      disabled={isDisabledNext}
      heading={t('Who Would You Like to Perform an Action On?')}
      leftBtn={null}
      onConfirm={nextAction}
      onHide={onHide}
      show={show}
      size="medium"
      {...props}
    >
      <ModalContents>
        <Select
          label={t('Choose Action Group')}
          options={selectionOptions}
          value={option}
          onChange={(op) => setOption(op)}
          placeholder={t('Choose Group')}
          onMenuOpen={onMenuOpen}
          components={{
            NoOptionsMessage,
          }}
          noOptionsMessage={t('Loading Options')}
          isOptionDisabled={(o) => o.disabled}
        />
      </ModalContents>
    </BasicModal>
  );
};

export default ConfirmActionModal;
